import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import { useState } from 'react';

import { amortizationOptions } from '@roc/feature-loans';
import { insertIf, isGroundUp, isStabilizedBridge } from '@roc/feature-utils';
import { formatCurrency } from '@roc/ui/utils';
import { observer } from 'mobx-react';
import { DetailsTable, DetailsTableField } from '../common/detailsTable';
import { TitleDivider } from '../common/titleDivider';
import { IQuoteTypeStore } from '../../stores/common/iQuoteTypeStore';

interface LoanDetailsAccordionProps {
  store: IQuoteTypeStore;
}

function getLoanDetail(store): DetailsTableField[] {
  const calculatedFields = store.loanEconomicsStore.calculateFields();
  return [
    ...insertIf(!isStabilizedBridge(store.loanSubtype), [
      {
        label: 'Initial Advance',
        value: (
          <Typography>
            {formatCurrency(calculatedFields?.initialAdvance)}
          </Typography>
        ),
        colSpan: 1,
      },
      {
        label: 'Construction Holdback',
        value: formatCurrency(calculatedFields.constructionHoldback),
        colSpan: 1,
      },
    ]),
    ...insertIf(isStabilizedBridge(store.loanSubtype), [
      {
        label: 'Loan Amount',
        value: (
          <Typography>
            {formatCurrency(calculatedFields?.totalLoanAmount)}
          </Typography>
        ),
        colSpan: 1,
      },
    ]),
    {
      label: 'Interest Reserve',
      value: `${formatCurrency(calculatedFields?.interestReserve)}`,
      colSpan:
        isStabilizedBridge(store.loanSubtype)
          ? 1
          : 2,
    },
  ];
}

export const LoanDetailsAccordion = observer(
  ({ store }: LoanDetailsAccordionProps) => {
    const [expanded, setExpanded] = useState(true);

    function loanDetails(): DetailsTableField[] {
      return getLoanDetail(store);
    }

    return (
      <Accordion
        expanded={expanded}
        onChange={(e, expanded) => setExpanded(expanded)}
        elevation={0}
      >
        <AccordionSummary
          expandIcon={<ExpandMore fontSize="large" />}
          aria-controls="loan-details-accordion"
        >
          <TitleDivider title="Loan Details" />
        </AccordionSummary>
        <AccordionDetails>
          <DetailsTable fields={loanDetails()} />
        </AccordionDetails>
      </Accordion>
    );
  }
);

const getAmortizationLabelFromValue = value => {
  const option = amortizationOptions.find(opt => opt.value === value);
  return option ? option.label : value;
};
